import { List } from 'immutable';
import { ChatSessionKey } from 'flow/types/EntityKeys';
import { State } from 'flow/types/State';

export const selectSocialIntegrationSettings = (state: State) =>
    state.socialIntegration.get('socialIntegrationSettings');

/**
 * Whether the user has actually completed linking their Microsoft account
 * (calendar/contacts sync), not merely whether they're entitled to —
 * mirrors the "connected" check in Setting/Account/SocialIntegration.tsx.
 */
export const selectHasMicrosoftAccountLinked = (state: State) =>
    !!state.socialIntegration.getIn([
        'socialIntegrationSettings',
        'microsoft',
        'email',
    ]);

/* Oldest first, as stored. Reverse at the call site, memoised on this: a reversed List is a
 * new object every call, which no reference check can hold. */
export const selectSessionCloudFiles = (
    state: State,
    chatSessionKey: ChatSessionKey,
) =>
    state.socialIntegration.getIn(
        ['cloudFiles', chatSessionKey, 'files'],
        List(),
    );
